export const generatedSpaceEnvironmentEvidenceLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-20T00:00:00.000Z",
  "mode": "deterministic-space-environment-evidence-ledger",
  "operatingRule": "Space-environment, radiation, solar-weather, and comms-disruption assumptions require reviewed SPDF/CDAWeb payloads, CCMC or equivalent model-run artifacts, dated SWPC products, standards-linked architecture records, units, uncertainty, and reviewer approval before claims can promote.",
  "recordCount": 4,
  "blockedRecordCount": 4,
  "promotionAllowed": false,
  "artifactContract": {
    "id": "artifact-space-environment-v1",
    "name": "Space environment and radiation evidence contract",
    "claimState": "hypothesis",
    "runtimeStatus": "design-contract",
    "nextAction": "Add SPDF/CCMC/SWPC adapters for site-specific radiation and solar-weather assumptions.",
    "readinessInputs": {
      "sourceTraceability": 0.55,
      "queryReproducibility": 0.35,
      "unitsCoverage": 0.45,
      "uncertaintyCoverage": 0.35,
      "runtimeGenerated": 0,
      "independentValidation": 0
    }
  },
  "evidenceHashes": {
    "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
    "capabilityMaturityLedger": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
    "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
    "scenarioDefinitions": "sha256-5f42bfe12b4b4df1dcaaa4af1d270088b5f2d0689d2dda2163b26e1ffd34291c"
  },
  "sourceFamilyCoverage": [
    {
      "sourceId": "nasa-spdf",
      "present": true,
      "recordHash": "fnv1a32-05f4400c"
    },
    {
      "sourceId": "nasa-ccmc",
      "present": true,
      "recordHash": "fnv1a32-1a450de5"
    },
    {
      "sourceId": "noaa-swpc",
      "present": true,
      "recordHash": "fnv1a32-dbbbdd09"
    },
    {
      "sourceId": "nasa-dtn",
      "present": true,
      "recordHash": "fnv1a32-61e03fe6"
    },
    {
      "sourceId": "ccsds",
      "present": true,
      "recordHash": "fnv1a32-75fdfe19"
    }
  ],
  "linkedAssumptions": [
    {
      "id": "assumption-snapshot-first",
      "title": "Browser consumes reviewed snapshots first",
      "state": "validated-product-rule",
      "uncertainty": "Low",
      "testGate": "All displayed science claims must resolve to local source records or reviewed artifacts."
    },
    {
      "id": "assumption-no-mercury-first",
      "title": "Mercury cannot be hardcoded as the winning scenario",
      "state": "validated-product-rule",
      "uncertainty": "Low",
      "testGate": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury."
    }
  ],
  "capabilityContext": {
    "id": "space-environment",
    "maturityScore": 65.22,
    "maturityBand": "research-backed",
    "commercializationAllowed": false,
    "blockerCount": 1
  },
  "topEnvironmentGaps": [
    {
      "id": "ccmc-space-weather-model-run",
      "label": "NASA CCMC model-run custody",
      "evidenceScore": 63,
      "highestStressScenarioId": "mercury-orbit",
      "highestEnvironmentBurden": 80,
      "blockerCount": 3,
      "nextAction": "model selection and version"
    },
    {
      "id": "swpc-product-forecast-archive-context",
      "label": "NOAA SWPC dated product and alert context",
      "evidenceScore": 63,
      "highestStressScenarioId": "mercury-orbit",
      "highestEnvironmentBurden": 80,
      "blockerCount": 3,
      "nextAction": "product id and issue timestamp"
    },
    {
      "id": "spdf-cdaweb-radiation-plasma-intake",
      "label": "NASA SPDF/CDAWeb radiation and plasma source intake",
      "evidenceScore": 66,
      "highestStressScenarioId": "mercury-orbit",
      "highestEnvironmentBurden": 80,
      "blockerCount": 3,
      "nextAction": "CDAWeb dataset id and variable list"
    },
    {
      "id": "dtn-comms-disruption-architecture",
      "label": "DTN and space-data standards disruption architecture",
      "evidenceScore": 66,
      "highestStressScenarioId": "mercury-orbit",
      "highestEnvironmentBurden": 80,
      "blockerCount": 3,
      "nextAction": "selected standard or architecture document"
    }
  ],
  "records": [
    {
      "id": "spdf-cdaweb-radiation-plasma-intake",
      "label": "NASA SPDF/CDAWeb radiation and plasma source intake",
      "evidenceFamily": "heliophysics-archive-source-custody",
      "currentUse": "Defines the required custody envelope for particle, plasma, and field datasets before site-specific radiation assumptions can influence scenario ranking.",
      "dataState": "source-surface-linked-no-dataset-payload",
      "unitsRequired": [
        "CDF dataset id",
        "time range",
        "cadence",
        "particle/plasma/field variables"
      ],
      "requiredPayloads": [
        "CDAWeb dataset id and variable list",
        "retrieval timestamp and query URL or API parameters",
        "raw payload hash and normalized time-series hash",
        "instrument calibration and archive-version note"
      ],
      "requiredRuntimeArtifacts": [
        "site/time-window environment snapshot",
        "shielding or exposure assumption record",
        "scenario-specific radiation/plasma risk sensitivity run"
      ],
      "modelInputRefs": [
        "scenario.risks.thermal",
        "scenario.risks.comms",
        "capability.space-environment"
      ],
      "sourceRefs": [
        {
          "sourceId": "nasa-spdf",
          "title": "NASA Space Physics Data Facility",
          "trust": "primary",
          "sourceType": "heliophysics-data-archive",
          "recordHash": "fnv1a32-05f4400c",
          "url": "https://spdf.gsfc.nasa.gov/",
          "queryPolicy": "Dataset id, variables, time range, cadence, and retrieval hash required.",
          "uncertaintyMode": "Instrument calibration, cadence, and archive-version caveats."
        }
      ],
      "missingSourceIds": [],
      "scenarioStress": [
        {
          "scenarioId": "mercury-orbit",
          "scenarioName": "Mercury Orbit-first",
          "commsBurden": 78,
          "thermalBurden": 82,
          "autonomyBurden": 75.6,
          "environmentBurden": 80
        },
        {
          "scenarioId": "asteroid-first",
          "scenarioName": "Asteroid Feedstock-first",
          "commsBurden": 48,
          "thermalBurden": 38,
          "autonomyBurden": 51.48,
          "environmentBurden": 47.68
        },
        {
          "scenarioId": "hybrid",
          "scenarioName": "Hybrid Moon -> Asteroid -> Mercury",
          "commsBurden": 42,
          "thermalBurden": 45,
          "autonomyBurden": 43.68,
          "environmentBurden": 45.5
        },
        {
          "scenarioId": "mars-first",
          "scenarioName": "Mars-first Conventional Expansion",
          "commsBurden": 64,
          "thermalBurden": 56,
          "autonomyBurden": 58.84,
          "environmentBurden": 58.12
        }
      ],
      "highestStressScenario": {
        "scenarioId": "mercury-orbit",
        "scenarioName": "Mercury Orbit-first",
        "commsBurden": 78,
        "thermalBurden": 82,
        "autonomyBurden": 75.6,
        "environmentBurden": 80
      },
      "evidenceScore": 66,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-environment-proof",
        "blockers": [
          "No reviewed SPDF/CCMC/SWPC/standards payload has been promoted.",
          "No mission/site-specific environment or comms-disruption runtime artifact is attached.",
          "Space-environment evidence is not yet allowed to promote radiation, blackout, or long-range forecast claims."
        ],
        "allowedUse": "May be used only as environment-risk context, source backlog, and sensitivity planning evidence."
      },
      "evidenceHash": "sha256-a614bd905f279c9df33644284a09b574a589b9a28bf4b389e1fd9ee2cb72b9f6"
    },
    {
      "id": "ccmc-space-weather-model-run",
      "label": "NASA CCMC model-run custody",
      "evidenceFamily": "space-weather-model-runtime-custody",
      "currentUse": "Defines the required input/output custody for solar-wind, heliosphere, or magnetosphere model runs before environment stress claims can promote.",
      "dataState": "source-surface-linked-no-model-run",
      "unitsRequired": [
        "model name",
        "model version",
        "run id",
        "input deck hash",
        "output hash"
      ],
      "requiredPayloads": [
        "model selection and version",
        "input deck with time range and boundary conditions",
        "run identifier or reproducible local command",
        "output artifact hash and reviewer notes"
      ],
      "requiredRuntimeArtifacts": [
        "reviewed CCMC or equivalent model-run artifact",
        "cross-check against SPDF/SWPC source records",
        "uncertainty envelope or validation residual record"
      ],
      "modelInputRefs": [
        "modelArtifacts.artifact-space-environment-v1",
        "scenarioDecision.blockers"
      ],
      "sourceRefs": [
        {
          "sourceId": "nasa-ccmc",
          "title": "Community Coordinated Modeling Center",
          "trust": "primary",
          "sourceType": "space-weather-modeling-center",
          "recordHash": "fnv1a32-1a450de5",
          "url": "https://ccmc.gsfc.nasa.gov/",
          "queryPolicy": "Model, run id, inputs, version, and output hash required.",
          "uncertaintyMode": "Model validation state, run configuration, and uncertainty bounds."
        }
      ],
      "missingSourceIds": [],
      "scenarioStress": [
        {
          "scenarioId": "mercury-orbit",
          "scenarioName": "Mercury Orbit-first",
          "commsBurden": 78,
          "thermalBurden": 82,
          "autonomyBurden": 75.6,
          "environmentBurden": 80
        },
        {
          "scenarioId": "hybrid",
          "scenarioName": "Hybrid Moon -> Asteroid -> Mercury",
          "commsBurden": 42,
          "thermalBurden": 45,
          "autonomyBurden": 43.68,
          "environmentBurden": 45.5
        },
        {
          "scenarioId": "asteroid-first",
          "scenarioName": "Asteroid Feedstock-first",
          "commsBurden": 48,
          "thermalBurden": 38,
          "autonomyBurden": 51.48,
          "environmentBurden": 47.68
        }
      ],
      "highestStressScenario": {
        "scenarioId": "mercury-orbit",
        "scenarioName": "Mercury Orbit-first",
        "commsBurden": 78,
        "thermalBurden": 82,
        "autonomyBurden": 75.6,
        "environmentBurden": 80
      },
      "evidenceScore": 63,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-environment-proof",
        "blockers": [
          "No reviewed SPDF/CCMC/SWPC/standards payload has been promoted.",
          "No mission/site-specific environment or comms-disruption runtime artifact is attached.",
          "Space-environment evidence is not yet allowed to promote radiation, blackout, or long-range forecast claims."
        ],
        "allowedUse": "May be used only as environment-risk context, source backlog, and sensitivity planning evidence."
      },
      "evidenceHash": "sha256-9d9fa6f9ac3e036ff60f7da3208a35878b89519138b15e37125bf21a1c24cca7"
    },
    {
      "id": "swpc-product-forecast-archive-context",
      "label": "NOAA SWPC dated product and alert context",
      "evidenceFamily": "space-weather-product-context",
      "currentUse": "Provides operational context for solar-radio, proton flux, geomagnetic, and alert products; not a deterministic long-range forecast.",
      "dataState": "source-surface-linked-no-product-payload",
      "unitsRequired": [
        "product id",
        "issue time",
        "forecast horizon",
        "Kp/Ap/F10.7/particle flux where applicable"
      ],
      "requiredPayloads": [
        "product id and issue timestamp",
        "forecast or archive horizon",
        "values with units and product caveats",
        "retrieval hash and archive link"
      ],
      "requiredRuntimeArtifacts": [
        "dated SWPC product capture",
        "mapping from product variables to scenario risk inputs",
        "review note preventing long-range deterministic overuse"
      ],
      "modelInputRefs": [
        "scenario.risks.comms",
        "autonomyLoadIndex",
        "blackoutSafeManufacturingWindow"
      ],
      "sourceRefs": [
        {
          "sourceId": "noaa-swpc",
          "title": "NOAA Space Weather Prediction Center Products and Data",
          "trust": "primary",
          "sourceType": "space-weather-products",
          "recordHash": "fnv1a32-dbbbdd09",
          "url": "https://www.spaceweather.gov/products-and-data",
          "queryPolicy": "Product id, issue time, forecast horizon, and archive link required.",
          "uncertaintyMode": "Forecast horizon and product-specific verification notes."
        }
      ],
      "missingSourceIds": [],
      "scenarioStress": [
        {
          "scenarioId": "moon-first",
          "scenarioName": "Moon-first Bootstrap",
          "commsBurden": 15,
          "thermalBurden": 48,
          "autonomyBurden": 22.32,
          "environmentBurden": 34.82
        },
        {
          "scenarioId": "hybrid",
          "scenarioName": "Hybrid Moon -> Asteroid -> Mercury",
          "commsBurden": 42,
          "thermalBurden": 45,
          "autonomyBurden": 43.68,
          "environmentBurden": 45.5
        },
        {
          "scenarioId": "mercury-orbit",
          "scenarioName": "Mercury Orbit-first",
          "commsBurden": 78,
          "thermalBurden": 82,
          "autonomyBurden": 75.6,
          "environmentBurden": 80
        }
      ],
      "highestStressScenario": {
        "scenarioId": "mercury-orbit",
        "scenarioName": "Mercury Orbit-first",
        "commsBurden": 78,
        "thermalBurden": 82,
        "autonomyBurden": 75.6,
        "environmentBurden": 80
      },
      "evidenceScore": 63,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-environment-proof",
        "blockers": [
          "No reviewed SPDF/CCMC/SWPC/standards payload has been promoted.",
          "No mission/site-specific environment or comms-disruption runtime artifact is attached.",
          "Space-environment evidence is not yet allowed to promote radiation, blackout, or long-range forecast claims."
        ],
        "allowedUse": "May be used only as environment-risk context, source backlog, and sensitivity planning evidence."
      },
      "evidenceHash": "sha256-0316918c2d59f2b6f6ae9a01ad364329450a3ece4bf5727e06c31d14996edfed"
    },
    {
      "id": "dtn-comms-disruption-architecture",
      "label": "DTN and space-data standards disruption architecture",
      "evidenceFamily": "communications-autonomy-standards-context",
      "currentUse": "Keeps store-and-forward, outage tolerance, and contact-loss assumptions standards-linked but unpromoted until mission-specific link budgets exist.",
      "dataState": "standards-linked-no-mission-architecture",
      "unitsRequired": [
        "protocol version",
        "contact plan",
        "latency",
        "data volume",
        "custody/forwarding assumption"
      ],
      "requiredPayloads": [
        "selected standard or architecture document",
        "mission contact plan and link-budget input",
        "latency/outage envelope",
        "DTN custody, storage, and priority assumptions"
      ],
      "requiredRuntimeArtifacts": [
        "mission-specific contact simulation",
        "blackout-safe process-window test",
        "data-volume and autonomy-reserve sensitivity run"
      ],
      "modelInputRefs": [
        "scenario.risks.comms",
        "blackoutSafeManufacturingWindow",
        "autonomyLoadIndex"
      ],
      "sourceRefs": [
        {
          "sourceId": "nasa-dtn",
          "title": "Delay/Disruption Tolerant Networking",
          "trust": "primary",
          "sourceType": "communications-program-reference",
          "recordHash": "fnv1a32-61e03fe6",
          "url": "https://www.nasa.gov/communicating-with-missions/delay-disruption-tolerant-networking/",
          "queryPolicy": "Program reference, architecture assumption, and scenario mapping required.",
          "uncertaintyMode": "Conceptual architecture until mission-specific link data exists."
        },
        {
          "sourceId": "ccsds",
          "title": "Consultative Committee for Space Data Systems",
          "trust": "primary",
          "sourceType": "space-data-standard",
          "recordHash": "fnv1a32-75fdfe19",
          "url": "https://ccsds.org/",
          "queryPolicy": "Publication id, version, area, and applied assumption required.",
          "uncertaintyMode": "Standards conformance caveats and mission-specific implementation deltas."
        }
      ],
      "missingSourceIds": [],
      "scenarioStress": [
        {
          "scenarioId": "mercury-orbit",
          "scenarioName": "Mercury Orbit-first",
          "commsBurden": 78,
          "thermalBurden": 82,
          "autonomyBurden": 75.6,
          "environmentBurden": 80
        },
        {
          "scenarioId": "asteroid-first",
          "scenarioName": "Asteroid Feedstock-first",
          "commsBurden": 48,
          "thermalBurden": 38,
          "autonomyBurden": 51.48,
          "environmentBurden": 47.68
        },
        {
          "scenarioId": "hybrid",
          "scenarioName": "Hybrid Moon -> Asteroid -> Mercury",
          "commsBurden": 42,
          "thermalBurden": 45,
          "autonomyBurden": 43.68,
          "environmentBurden": 45.5
        },
        {
          "scenarioId": "mars-first",
          "scenarioName": "Mars-first Conventional Expansion",
          "commsBurden": 64,
          "thermalBurden": 56,
          "autonomyBurden": 58.84,
          "environmentBurden": 58.12
        }
      ],
      "highestStressScenario": {
        "scenarioId": "mercury-orbit",
        "scenarioName": "Mercury Orbit-first",
        "commsBurden": 78,
        "thermalBurden": 82,
        "autonomyBurden": 75.6,
        "environmentBurden": 80
      },
      "evidenceScore": 66,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-environment-proof",
        "blockers": [
          "No reviewed SPDF/CCMC/SWPC/standards payload has been promoted.",
          "No mission/site-specific environment or comms-disruption runtime artifact is attached.",
          "Space-environment evidence is not yet allowed to promote radiation, blackout, or long-range forecast claims."
        ],
        "allowedUse": "May be used only as environment-risk context, source backlog, and sensitivity planning evidence."
      },
      "evidenceHash": "sha256-82516d4316ba696d48c908182eb14967afd68156b9ad63054e3f75037dd9a65d"
    }
  ],
  "ledgerHash": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23"
}
;
